export default __webpack_public_path__ + "static/media/pricing-card.5f5417d6.JPG";